module.exports = __webpack_public_path__ + "static/media/bg-japan-kabayaki.0d88d760.png";